export const getRelocationEquipmentAttachmentListErrMsg =
  'Ошибка получения изображений с перемещения оборудования'

export const getRelocationEquipmentTechnicalExaminationErrMsg =
  'Ошибка получения технической экспертизы при перемещении оборудования'

export const createRelocationEquipmentTechnicalExaminationErrMsg =
  'Ошибка создания технической экспертизы при перемещении оборудования'
